import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getProductsBySearch = async (searchText: string) => {
  const { data, error } = await supabase
    .from('products_with_details')
    .select('*')
    .or(`name.ilike.%${searchText}%,brand_name.ilike.%${searchText}%,subcategory_name.ilike.%${searchText}%`);

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export default function useGetProductBySearch(searchText: string) {
  return useQuery({
    queryKey: ['useGetProductBySearch', searchText],
    queryFn: () => getProductsBySearch(searchText),
    enabled: searchText.length > 0,
    staleTime: 0,
  });
}
